import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { excellenceAppsConfig } from 'components/Dashboards/ExcellenceApps/excellenceAppsConfig';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { MainContent } from 'components/common/PageContainer/MainContent';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { TreeProgramTopHeader } from 'components/common';
import { SimulationSteps } from 'components/widgets/ScheduleSimulation/SimulationMain/SimulationSteps';
import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { queryKey as runSimulationQueryKey } from 'api/queries/getSchedulingSimulationResults.query';
import { TitleWithBeta } from 'components/common/titleWithBeta/titleWithBeta';
import { listCardsDataQueryKey } from 'api/queries/getListFilteredCards.query';

export const ScheduleSimulation = () => {
    useFullStoryPageView({ pageName: excellenceAppsConfig.scheduleSimulation.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader
                            pageTitle={<TitleWithBeta title={excellenceAppsConfig.scheduleSimulation.title} />}
                        />
                    </VersionSection>
                </VersionWrapper>
            </HeaderWrapper>
            <MainContent>
                <SimulationSteps />
            </MainContent>
            <MainCardRoutingModal queryKeys={[runSimulationQueryKey, listCardsDataQueryKey]} />
        </PageContainer>
    );
};
